import { FC, useEffect, useState } from 'react';
import { makeStyles } from '@fluentui/react-components';
import { useGptConfigurations } from '../../store/hooks';
import { IGptConfiguration } from '../../EnterpriseGPTApi/EnterpriseGPTApiV1Client';
import { getGptIconAsset } from '../../Utils/image';
import { OpenAiLogo } from './OpenAiLogo';

export interface GptIconProps {
    gptId: string | undefined;
    theme?: 'light'  | 'dark' | undefined;
    width?: string;
}

const useStyles = makeStyles({
    defaultGptContainerLogo: {
        display: 'flex',
        height: '35px',
        width: '80px',
    },
    gptContainerLogo: {
        display: 'flex',
        height: '25px',
        width: '80px',
    }
});

export const GptIcon: FC<GptIconProps> = ({gptId, theme, width}: GptIconProps) => {
    const classes = useStyles();
    const { gptConfigurations } = useGptConfigurations();
    const [ gptConfig, setGptConfig ] = useState<IGptConfiguration | undefined>();
    
    useEffect(() => {
        const currentGptConfig = gptConfigurations.find(x => x.id === gptId);
        setGptConfig(currentGptConfig);
    }, [gptId]) // gptConfigurations intentionally omitted to avoid unnecessary re-renders
    
    const containerStyle = width ? { width } : {};
    
    return (
        <div 
            className={gptConfig?.isDefault ? classes.defaultGptContainerLogo : classes.gptContainerLogo}
            style={containerStyle}
        >
            {gptConfig?.isDefault ? 
                <OpenAiLogo size='small' theme={theme} /> : 
                <img src={getGptIconAsset(gptConfig?.icon)} />
            } 
        </div>
    );
};
